import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuperAdminGuardDirective } from './directives/super-admin-guard.directive';

@NgModule({
	declarations: [SuperAdminGuardDirective],
	imports: [CommonModule],
	providers: [],
	exports: [SuperAdminGuardDirective],
})
export class AuthenticationModule {}

export * from './service/authentication.service';
export * from './auth.guard';
export * from './super-admin.guard';
export * from './util/authorization-params';
export * from './directives/super-admin-guard.directive';
